import '../assets/css/reset.css';
import '../assets/css/common.css';
import './index.css';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import EmblaCarousel from 'embla-carousel';
import {
  getInfoOfDeviceOS,
  getQuerystring,
  OLD_API_URL,
  requestGET,
} from '../assets/js/common-es6';
import {
  locationMovement,
  webkitBridgeMixpanelCustomEvent,
} from '../components/utils/locationMovement';

const isApp = getQuerystring('isApp');
let accessToken = '';
let accessTokenExpiredAt = '';
let refreshToken = '';
let refreshTokenExpiredAt = '';

if (isApp) {
  sessionStorage.isApp = true;

  accessToken = getQuerystring('accessToken') ?? '';
  accessTokenExpiredAt = getQuerystring('accessTokenExpiredAt') ?? '';
  refreshToken = getQuerystring('refreshToken') ?? '';
  refreshTokenExpiredAt = getQuerystring('refreshTokenExpiredAt') ?? '';
}

window.addEventListener('DOMContentLoaded', () => {
  const curationOptions = {
    dragFree: false,
    loop: true,
  };

  EmblaCarousel(document.getElementsByClassName('wrapper-reviews')[0], curationOptions);
  // EmblaCarousel(document.getElementsByClassName('wrapper-reviews')[1], curationOptions);

  //
  document.getElementsByClassName('btn_fixed')[0].addEventListener('click', () => {
    if (isApp) {
      locationMovement('internal_web', {
        title: '',
        redirectUrl: '/service/counseling/coordinator/',
      });
    } else {
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  });

  // document.getElementsByClassName('btn_fixed')[0].addEventListener('click', () => {
  //   if (isApp) {
  //     locationMovement('internal_web', {
  //       title: '',
  //       redirectUrl: '/service/counseling/coordinator/',
  //     });
  //   } else if (window.pageYOffset < document.getElementsByClassName('area_trost-guide')[0].offsetTop - 100) {
  //     window.scrollTo({
  //       behavior: 'smooth',
  //       left: 0,
  //       top: document.getElementsByClassName('area_trost-guide')[0].offsetTop - 60,
  //     });
  //   } else {
  //     window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
  //   }
  // });

  //
  // document.getElementsByClassName('area_fixed')[0].style.display = 'block';
  document.getElementById('appDownloadFloatingPopup').style.bottom = '70px';
  // document.getElementById('appDownloadFloatingPopup').style.left = 'auto';
  // document.getElementById('appDownloadFloatingPopup').style.right = '20px';

  //
  for (let i = 0; i < document.getElementsByClassName('js_btn-find-partners').length; i += 1) {
    document.getElementsByClassName('js_btn-find-partners')[i].style.display = 'block';

    document.getElementsByClassName('js_btn-find-partners')[i].addEventListener('click', () => {
      const partnerId = document.getElementsByClassName('js_btn-find-partners')[i].classList[1];
      const partnerName = document.getElementsByClassName('partner_profile')[i].getElementsByTagName('strong')[0].innerText.split(' ')[0];
      const reviewContent = document.getElementsByClassName('review_content')[i].innerText;
      const listId = window.location.pathname.split('/')[2];

      if (partnerId) {
        webkitBridgeMixpanelCustomEvent('심리상담리뷰선택', {
          페이지이름: 'SEO_리뷰',
          리스트이름: listId,
          리뷰내용: reviewContent,
          상담사아이디: partnerId,
          상담사이름: partnerName,
          플랫폼: 'App',
        });

        webkitBridgeMixpanelCustomEvent('상품선택', {
          페이지이름: 'SEO_리뷰',
          리스트이름: listId,
          상품상세유형: ['상담'],
          상담사id: partnerId,
          상담타입: '일반',
          상담유형: [],
          상담사성별: '',
          상담사레벨: '',
          상담사추천: '',
          상담사신규: '',
          상담횟수: 0,
          별점: 0,
          리뷰수: 0,
          플랫폼: 'App',
        });
      }

      if (isApp) {
        if (partnerId) {
          locationMovement('findPartners', { id: partnerId });
        } else {
          locationMovement('findPartners', {});
        }
      } else {
        window.location.href = `/mobile/partner/detail/?partnerID=${partnerId}`;
      }
    });
  }

  if (isApp) {
    document.getElementsByClassName('a_btn')[0].style.display = 'none';

    document.getElementsByClassName('a_btn_last_guide_counseling_guide')[0].setAttribute('target', '_self');
    document.getElementsByClassName('a_btn_last_guide_counseling_guide')[0].setAttribute('href', 'hctrost://webview?title=상담 가이드북&url=https://humartcompany.notion.site/6-A-to-Z-f5cb4991953e4fcd8157c67a1a1ff09d');
    document.getElementsByClassName('a_btn_last_guide_payback')[0].setAttribute('target', '_self');
    document.getElementsByClassName('a_btn_last_guide_payback')[0].setAttribute('href', `hctrost://webview?title=상담만족 보상제도&url=https://${window.location.host}/promotion/payback/`);

    // document.getElementsByClassName('btn_fixed')[0].innerHTML = '(무료) 내 고민에 딱! 맞는 상담사 추천받기 ➡️';
  }

  //
  if (document.getElementsByClassName('counseling-intensive-course-el')[0]) {
    requestGET(`${OLD_API_URL}/trostCuration/v2/?content=curationIntensiveCourse`, (status, resData) => {
      if (!status) {
        return false;
      }

      const slideData = resData.data;
      let slideDataEl = '';

      slideData.forEach((item) => {
        if (isApp) {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
        } else {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-course/?course_id=${item.courseId}';"><img alt="${item.courseTitle} 배너" src="${item.courseThumbnailImage}"></div>`;
        }
      });

      if (slideDataEl) {
        document.getElementsByClassName('counseling-intensive-course-el')[0].innerHTML = `<div class="embla__container">${slideDataEl}</div>`;
        EmblaCarousel(document.getElementsByClassName('counseling-intensive-course-el')[0], {
          dragFree: false,
          loop: true,
          startIndex: 0,
        });
      }
    });
  }

  //
  if (document.getElementsByClassName('counseling-tests-el')[0]) {
    requestGET(`${OLD_API_URL}/trostCuration/v2/?content=counselingTests`, (status, resData) => {
      if (!status) {
        return false;
      }

      const slideData = resData.data;
      let slideDataEl = '';

      slideData.forEach((item) => {
        if (isApp) {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-test/?content_link_id=${item.contentLinkId}&isApp=1&accessToken=${accessToken}&accessTokenExpiredAt=${accessTokenExpiredAt}&refreshToken=${refreshToken}&refreshTokenExpiredAt=${refreshTokenExpiredAt}';"><img src="${item.thumbnailImage}" alt="${item.title} 배너"/><p>${item.title}</p></div>`;
        } else {
          slideDataEl += `<div class="embla__slide" onclick="window.location.href = '/mobile/curation-test/?content_link_id=${item.contentLinkId}';"><img src="${item.thumbnailImage}" alt="${item.title} 배너"/><p>${item.title}</p></div>`;
        }
      });

      if (slideDataEl) {
        document.getElementsByClassName('counseling-tests-el')[0].innerHTML = `<div class="embla__container">${slideDataEl}</div>`;
        EmblaCarousel(document.getElementsByClassName('counseling-tests-el')[0], {
          dragFree: false,
          loop: true,
          startIndex: 0,
        });
      }
    });
  }

  // 모바일 대응
  if (isApp) {
    document.getElementsByClassName('top-banners__wrapper')[0].style.display = 'block';
    document.getElementsByClassName('redirect-ai-coordinator')[0].addEventListener('click', () => {
      locationMovement('internal_web', {
        title: '',
        redirectUrl: '/service/counseling/coordinator/',
      });
    });

    if (isApp && getInfoOfDeviceOS() === 'ios') {
      for (let i = 0; i < document.getElementsByClassName('google-ad__wrapper').length; i += 1) {
        document.getElementsByClassName('google-ad__wrapper')[i].style.display = 'none';
      }
    }
  }
});
